<template>
  <v-dialog persistent v-model="dialogVisible" width="40rem">
    <v-card>
      <v-card-title class="primary--text">Start Class</v-card-title>
      <v-form ref="form" v-model="startClassValidation.valid">
        <v-container>
          <v-card-title>
            Please select the Chapter and Lesson name for which you want to
            release the content
          </v-card-title>
          <v-row class="ma-1">
            <v-col>
              <v-select
                v-model="localCourseCoverage.chapterNo"
                :items="chapterList"
                label="Chapter Name"
                required
                outlined
                dense
                item-text="chapterName"
                item-value="chapterNo"
                @change="fetchLessons(localCourseCoverage.chapterNo)"
                :rules="startClassValidation.nameRules"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="localCourseCoverage.lessonNo"
                :items="lessons"
                label="Lesson Name"
                outlined
                dense
                item-text="lessonName"
                item-value="lessonNo"
                :required="localCourseCoverage.chapterNo > 0"
                :disabled="localCourseCoverage.chapterNo <= 0"
                :rules="lessonRules"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeDialog()">Cancel</v-btn>
            <v-btn color="primary" text @click="startClass()"
              >Start Class</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ClassStartDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      default: () => ({}),
    },
    topicCovered: {
      type: [Map, Object],
      default: () => new Map(),
    },
    editedClassOps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lessons: [],
      localCourseCoverage: {},
      startClassValidation: {
        valid: false,
        nameRules: [(v) => !!v || v === 0 || "This is required"],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    chapterList() {
      const defaults = [
        { chapterName: "Previous Chapter", chapterNo: -1 },
        { chapterName: "No Chapter", chapterNo: 0 },
      ];
      return this.course.chapters
        ? [...defaults, ...this.course.chapters]
        : defaults;
    },
    lessonRules() {
      return this.localCourseCoverage.chapterNo > 0
        ? this.startClassValidation.nameRules
        : [];
    },
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    fetchLessons(chapterNo) {
      this.lessons = [];
      if (chapterNo <= 0) return;

      let Chapter = this.course.chapters?.filter((chpt) => {
        return chpt.chapterNo == chapterNo;
      });
      if (Chapter && Chapter[0] && Chapter[0].lessons) {
        this.lessons = Chapter[0].lessons;
        const coveredLessons =
          this.topicCovered instanceof Map
            ? this.topicCovered.has(Number(chapterNo))
              ? this.topicCovered.get(Number(chapterNo))
              : null
            : this.topicCovered[Number(chapterNo)];

        if (coveredLessons) {
          this.lessons = this.lessons.filter((lesson) => {
            return !coveredLessons.includes(lesson.lessonNo);
          });
        }
      }
    },
    closeDialog() {
      this.resetForm();
      this.$emit("input", false);
    },
    resetForm() {
      this.localCourseCoverage = {};
      this.lessons = [];
      this.startClassValidation.valid = false;
    },
    startClass() {
      this.$refs.form.validate();
      if (this.startClassValidation.valid) {
        const { chapterNo, lessonNo } = this.localCourseCoverage;
        if (
          (chapterNo > 0 && lessonNo) ||
          chapterNo === 0 ||
          chapterNo === -1
        ) {
          this.$emit("start-class", {
            editedClassOps: this.editedClassOps,
            courseCoverage: this.localCourseCoverage,
          });
        }
      }
    },
  },
};
</script>
